module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/a4da7c7651cbc73697e878875d84f1da.png";